import React, { useState, Fragment, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useCookies } from 'react-cookie';
import queryString from 'query-string'

import { Spinner, Alert } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import FieldInput from "../../../../../components/FieldInput/FieldInput";
import Checkbox from "../../../../../components/Checkbox/Checkbox";
import * as actions from "../../../../../store/actions";

import { ThemingContext } from '../../../../../hoc/Theming/Theming';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "utils/msalAuthConfig";

import "./LoginForm.scss";

const LoginForm = (props) => {
  const { t } = useTranslation();
  const styling = useContext(ThemingContext);
  const query = queryString.parse(props.location.search)
  const {
    REACT_APP_AZURE_LOGIN, 
    REACT_APP_API_URL,
    REACT_APP_AZURE_REDIRECT,
    REACT_APP_AZURE_CLIENT_ID, 
    REACT_APP_AZURE_AUTHORITY,
    AZURE_TESTING_MODE,
    AZURE_EMAIL_TESTING,
    AZURE_MSALTOKEN_TESTING,
  } = window._app_config
  const isAuthenticated = useIsAuthenticated();

  const errors = useSelector((state) => state.user.errors);

  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false)

  const [cookies, setCookies] = useCookies([
    'email',
    'password'
  ])
  
  const [autoComplete, setAutoComplete] = useState({
    checked: false,
    data: {
      email: null,
      password: null,
    },
  });

  let [isLoading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if ( query.msalToken ) {
      dispatch(actions.login('user@msal.id', 'msal', { lang: 'en', msalToken: query.msalToken } ));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (  REACT_APP_AZURE_CLIENT_ID && REACT_APP_AZURE_AUTHORITY && isAuthenticated  && accounts[0] ) {
      instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0]
      }).then((response) => {
        dispatch(actions.login(response.account.username, 'msal', { lang: 'en', msalTokenFE: response.accessToken, msalName: response.account.name, azcid: REACT_APP_AZURE_CLIENT_ID, azauth: REACT_APP_AZURE_AUTHORITY } ));

      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const onLogin = (email, password) => {
    let params = {lang: 'en'}
    let lang = localStorage.getItem('language');

    if (lang !== null) {
      params = {lang: lang}
      localStorage.setItem("language", lang);
    } else {
      localStorage.setItem("language", params.lang);
    }

    dispatch(actions.login(email, password, params));
    setInterval(() => {
      setLoading(false);
    }, 500);
  };

  const inputHandler = (type) => (event) => {
    setLogin({ ...login, [type]: event.target.value });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    setLoading(true);
    onLogin(login.email.trim(), login.password.trim());

    let days = 7;
    const newDate = new Date(Date.now() + days * 24 * 60 * 60 * 1000);

    if(autoComplete.checked){
      setCookies('email', login.email, { path: '/', expires: newDate })
      setCookies('password', login.password, { path: '/', expires: newDate })
    }else{
      document.cookie = "email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "password=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  };

  const rememberMeHandler = () => {
    if (autoComplete.checked) {
      setAutoComplete({
        checked: false,
        data: {
          email: "off",
          password: "off",
        },
      });
    } else {
      setAutoComplete({
        checked: true,
        data: {
          email: login.email ? login.email : null,
          password: login.password ? login.password : null,
        },
      });
    }
  };

  const [alertSubs, setAlertSubs] = useState({
    show: false,
    type: "default",
    title: "",
    message: ""
  });

  useEffect(() => {
    if (errors && errors.subscription) {
      setAlertSubs({
        show: true,
        type: "danger",
        title: t("customerManagement.subscriptionExpired"),
        message: t("customerManagement.subscriptionExpiredSuggest")
      })
    }    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors])

  useEffect((login) => {
    if(cookies && cookies.email){
      setLogin({...login, 
        email: cookies.email,
        password: cookies.password
      })
      setAutoComplete({
        checked: true,
        data: {
          email: cookies.email,
          password: cookies.password
        }
      }) 
    }
  }, [cookies])

  const closeAlertSubs = () => {
    dispatch(actions.loginFailed({}))
    setAlertSubs({...alertSubs, show: false})
  }

  const loginAzure = () => {
    
    // msal frontend login
    if (  REACT_APP_AZURE_CLIENT_ID && REACT_APP_AZURE_AUTHORITY ) {
      instance.loginRedirect(loginRequest).catch(e => {
          console.log(e)
      });
    
    } else {
      if (AZURE_TESTING_MODE) {
        dispatch(actions.login(AZURE_EMAIL_TESTING, 'msal', { lang: 'en', msalToken: AZURE_MSALTOKEN_TESTING } ));
      } else {
        // msal backend
        window.location.replace(`${REACT_APP_API_URL}/auth/login-azure-msal`)
      }
    }   
  }

  
    // instance.logoutRedirect({
    //   postLogoutRedirectUri: "/",
    // });

  return (
    <Fragment>
      {errors && errors.attempts_message && (
              <Alert variant={'warning'}><small >{errors.attempts_message}</small></Alert>
        )}
    { REACT_APP_AZURE_REDIRECT && REACT_APP_AZURE_REDIRECT === 'true' ?   
      <form className="login__form" style={{ height: '375px'  }}>
        <AuthenticatedTemplate>
        <button type="button" className="btn btn-block btn-success"  >
          {t("login.azureSuccess")}
        </button> 
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
        <button type="button" className="btn btn-block btn-primary" onClick={loginAzure} >
          {t("login.azure")}
        </button> 
        </UnauthenticatedTemplate>
      </form> :   
      <form className="login__form" onSubmit={submitHandler} autoComplete="on" style={{ height: REACT_APP_AZURE_LOGIN && REACT_APP_AZURE_LOGIN === 'true' && '375px'  }}>
        <label htmlFor="login-email"></label>
        <FieldInput
          id="login-email"
          placeholder={t("E-mail")}
          name="email"
          value={login.email}
          inputHandler={() => inputHandler("email")}
          login
          type={t("usernameType")}
          autoComplete={autoComplete.data.email}
        />
        {errors && errors.email ? (
          <small className="text-danger ml-3">{errors.email}</small>
        ) : null}
        <label htmlFor="login-password"></label>
        <div style={{ position: 'relative' }}>
          <FieldInput
            id="login-password"
            placeholder="Password"
            name="password"
            value={login.password}
            inputHandler={() => inputHandler("password")}
            type={showPassword ? 'text' : 'password'}
            login
            autoComplete={autoComplete.data.password}
          />
          <i className="ic-eye-slash" onClick={() => setShowPassword(!showPassword)}/>
        </div>
        {errors && errors.password ? (
          <small className="text-danger ml-3">{errors.password}</small>
        ) : errors && errors.user ? (<small className="text-danger ml-3">{errors.user}</small>) : null}
        <div className="login__details">
          <div className="login__checkbox">
            <Checkbox checked={autoComplete.checked} changed={rememberMeHandler}>
              {t("login.rememberMe")}
            </Checkbox>
            {/* <Checkbox required>
              {t('login.agree')}{' '}
              <a className='text__bold' href="#foo">{t('login.termOfUse')}</a>
            </Checkbox> */}
          </div>
          <Link className="forgot__password" to="/recovery-password">
            {t("login.forgotPassword")}
          </Link>
        </div>
        <button id="btn-login-form" type="submit" style={styling.component.button.primary} className="btn btn-block">
          {isLoading ? (
            <span>
              <Spinner
                size="small"
                className="mr-2"
                animation="border"
                role="status"
              />
            </span>
          ) : (
            t("login.login")
          )}
        </button>
        { REACT_APP_AZURE_LOGIN && REACT_APP_AZURE_LOGIN === 'true' &&  
        <button type="button" className="btn btn-block btn-primary" onClick={loginAzure} >
          {t("login.azure")}
        </button>}
      </form> }
      <SweetAlert
        type={alertSubs.type}
        title={alertSubs.title}
        show={alertSubs.show}
        onConfirm={closeAlertSubs}
      >
        {alertSubs.message}
      </SweetAlert>
    </Fragment>
  );
};

export default withRouter(LoginForm);
